const userMixins = {
  computed: {
    isMasterUser() {
      return this.$store.state.user && this.$store.state.user.role === 'master';
    },

    superAdmin() {
      return this.$store.state.superAdmin;
    },

    roles() {
      return this.$store.state.userRoles;
    },

    user() {
      return this.$store.state.user;
    },

    users() {
      const sa = this.$store.state.user && this.$store.state.user.role === 'superadmin';

      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior === this.$store.state.user.level;
        } return x;
      });
    },
  },
  methods: {},
};

export default userMixins;
